import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=49fc9972&lang=pug&"
import script from "./DashboardHome.vue?vue&type=script&lang=ts&"
export * from "./DashboardHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports